import {
    Currency,
    ICurrency,
    ICurrencyData
} from './index'
import {
    IListResponse
} from '../abstract'
import {AxiosResponse} from "axios";

export const mockCurrenciesData = (): ICurrencyData[] => [
    {
        id: 1,
        slug: '€',
        name: 'EU',
        // coefficient: 1
    }, {
        id: 2,
        slug: '₽',
        name: 'RUB',
        // coefficient: 91
    }, {
        id: 3,
        slug: 'PLN',
        name: 'PLN',
        // coefficient: 4.47
    }
]

export const mockCurrencies = (data: ICurrencyData[] = mockCurrenciesData()): ICurrency[] =>
    data.map(item => new Currency(item))

export const mockCurrenciesApiResponse = (data: ICurrencyData[] = mockCurrenciesData()): Promise<AxiosResponse<IListResponse<ICurrencyData[]>>> =>
    Promise.resolve({
        data: {
            count: data.length,
            results: data
        },
        status: 200,
        statusText: 'Success',
        headers: {},
        config: {}
    })
